"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_actions_1 = __importDefault(require("../../redux/scenario/scenario.actions"));

var joi_1 = __importDefault(require("@hapi/joi"));

var editable_text_scenario_node_styles_1 = require("./editable-text-scenario-node.styles");

var editable_parsed_variable_text_component_1 = __importDefault(require("../editable-parsed-variable-text/editable-parsed-variable-text.component"));

var add_text_option_button_container_1 = __importDefault(require("../add-text-option-button/add-text-option-button.container"));

var sortable_text_option_list_container_1 = __importDefault(require("../sortable-text-option-list/sortable-text-option-list.container"));

var scenario_node_footer_button_box_container_1 = __importDefault(require("../scenario-node-footer-button-box/scenario-node-footer-button-box.container"));
/**
 * textScenarioNode options 最大値
 */


exports.MAX_TEXT_OPTIONS_LENGTH = 7;
/* validation
----------------------------------*/

var HEADER_MAX_LENGTH = 1000; // line messaging api 的には無制限。

var ERROR_MESSAGE = "1\u6587\u5B57\u4EE5\u4E0A".concat(HEADER_MAX_LENGTH, "\u6587\u5B57\u4EE5\u4E0B\u306E\u5024\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");

exports.isValidHeader = function (parsedText) {
  var schema = joi_1.default.string().max(HEADER_MAX_LENGTH).required();

  var _schema$validate = schema.validate(parsedText),
      error = _schema$validate.error;

  return {
    error: error ? ERROR_MESSAGE : null
  };
};

var EditableScenarioNodeHeaderContainer = function EditableScenarioNodeHeaderContainer(_ref) {
  var nodeId = _ref.nodeId,
      header = _ref.header;
  var dispatch = react_redux_1.useDispatch();
  return react_1.default.createElement(editable_parsed_variable_text_component_1.default, {
    rawText: header,
    handleSavedRawText: function handleSavedRawText(rawText) {
      return dispatch(scenario_actions_1.default.updateHeader({
        nodeId: nodeId,
        header: rawText
      }));
    },
    validate: exports.isValidHeader
  });
};

var EditableTextScenarioNode = function EditableTextScenarioNode(_ref2) {
  var nodeId = _ref2.nodeId,
      node = _ref2.node,
      design = _ref2.design;
  var options = node.options;
  return react_1.default.createElement(editable_text_scenario_node_styles_1.StyledEditableTextNodeDiv, {
    id: nodeId
  }, react_1.default.createElement(editable_text_scenario_node_styles_1.StyledEditableTextNodeHeaderDiv, {
    headerBackColor: design.headerBackColor,
    headerTextColor: design.headerTextColor
  }, react_1.default.createElement(EditableScenarioNodeHeaderContainer, {
    nodeId: nodeId,
    header: node.header
  })), react_1.default.createElement(editable_text_scenario_node_styles_1.StyledEditableTextNodeBodyDiv, {
    bodyBackColor: design.bodyBackColor,
    bodyTextColor: design.bodyTextColor
  }, react_1.default.createElement(sortable_text_option_list_container_1.default, {
    nodeId: nodeId,
    options: options
  }), options.length < exports.MAX_TEXT_OPTIONS_LENGTH && react_1.default.createElement(editable_text_scenario_node_styles_1.AddOptionWrapperDiv, null, react_1.default.createElement(add_text_option_button_container_1.default, {
    nodeId: nodeId
  })), react_1.default.createElement(scenario_node_footer_button_box_container_1.default, {
    node: node
  })));
};

exports.default = EditableTextScenarioNode;